import { memo } from 'react';
import type { CellContext } from '@tanstack/react-table';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Select as CommonSelect } from 'components/mui/common/Select';

interface Props<T, P> {
  value: string;
  row: CellContext<T, P>;
  onClick?: (row: T, cell: keyof P, newRow: T) => unknown;
  isClickable?: boolean;
  values?: string[];
  disableHelperText?: boolean;
}

const SelectBase = <T, P>({ value, row, onClick, isClickable, values, disableHelperText }: Props<T, P>) => {
  const { t } = useTranslation();

  return (
    <CommonSelect
      onChange={(e) => {
        if (!isClickable) return;

        e.stopPropagation();

        if (onClick) {
          onClick(row.row.original, row.column.id as keyof P, {
            ...row.row.original,
            [row.column.id as keyof P]: e.target.value,
          });
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      value={value}
      disableHelperText={disableHelperText}>
      {(values ?? []).map((val, index) => (
        <MenuItem key={index} value={val}>
          {t('common.' + val.toLocaleLowerCase())}
        </MenuItem>
      ))}
    </CommonSelect>
  );
};

export const Select = memo(SelectBase) as typeof SelectBase;
